<script>
import ETextFieldBase from '../ETextField'

import { VSelect } from 'vuetify/lib/components'
import { getObjectValueByPath } from 'vuetify/lib/util/helpers'
import mergeData from 'vuetify/lib/util/mergeData'
import EMenu from './../../EMenu/EMenu.vue'
import ESelectList from './ESelectList.vue'
import Vue from 'vue'
const ETextField = Vue.extend(ETextFieldBase)

export default {
  name: 'ESelect',
  mixins: [ETextField, VSelect],
  // extends: VSelect,
  props: {
    appendIcon: {
      type: String,
      default: 'icon-chevron-down',
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    hideDetails: {
      type: [Boolean, String],
      default: 'auto',
    },
    dense: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    classes() {
      return {
        ...ETextField.options.computed.classes.call(this),
        'v-select': true,
        'v-select--chips': this.hasChips,
        'v-select--chips--small': this.smallChips,
        'v-select--is-menu-active': this.isMenuActive,
        'v-select--is-multi': this.multiple,
        'e-select': true,
      }
    },
    staticList() {
      if (this.$slots['no-data'] || this.$slots['prepend-item'] || this.$slots['append-item']) {
      }

      return this.$createElement(ESelectList, { ...this.listData })
    },
  },
  methods: {
    genInput() {
      const input = ETextField.options.methods.genInput.call(this)
      delete input.data.attrs.name
      input.data = mergeData(input.data, {
        domProps: {
          value: null,
        },
        attrs: {
          readonly: true,
          type: 'text',
          'aria-readonly': String(this.isReadonly),
          'aria-activedescendant': getObjectValueByPath(this.$refs.menu, 'activeTile.id'),
          autocomplete: getObjectValueByPath(input.data, 'attrs.autocomplete', 'off'),
          placeholder: this.placeholder,
        },
        on: {
          keypress: this.onKeyPress,
        },
      })
      return input
    },
    genIcon(type, cb, extraData = {}) {
      return ETextField.options.methods.genIcon.call(this, type, cb, (extraData = {}))
    },
    genInputSlot() {
      const render = ETextField.options.methods.genInputSlot.call(this)
      render.data.attrs = {
        ...render.data.attrs,
        role: 'button',
        'aria-haspopup': 'listbox',
        'aria-expanded': String(this.isMenuActive),
        'aria-owns': this.computedOwns,
      }
      return render
    },
    genListWithSlot() {
      const slots = ['prepend-item', 'no-data', 'append-item']
        .filter((slotName) => this.$slots[slotName])
        .map((slotName) =>
          this.$createElement(
            'template',
            {
              slot: slotName,
            },
            this.$slots[slotName]
          )
        ) // Requires destructuring due to Vue
      // modifying the `on` property when passed
      // as a referenced object

      return this.$createElement(ESelectList, { ...this.listData }, slots)
    },

    genMenu() {
      const props = this.$_menuProps
      props.activator = this.$refs['input-slot'] // Attach to root el so that
      // menu covers prepend/append icons

      if (
        // TODO: make this a computed property or helper or something
        this.attach === '' || // If used as a boolean prop (<v-menu attach>)
        this.attach === true || // If bound to a boolean (<v-menu :attach="true">)
        this.attach === 'attach' // If bound as boolean prop in pug (v-menu(attach))
      ) {
        props.attach = this.$el
      } else {
        props.attach = this.attach
      }

      return this.$createElement(
        EMenu,
        {
          attrs: {
            role: undefined,
          },
          props,
          on: {
            input: (val) => {
              this.isMenuActive = val
              this.isFocused = val
            },
            scroll: this.onScroll,
          },
          ref: 'menu',
        },
        [this.genList()]
      )
    },
    genLabel() {
      return ETextField.options.methods.genLabel.call(this)
    },
    genFieldset() {
      if (!this.outlined) return null
      return this.$createElement(
        'fieldset',
        {
          attrs: {
            'aria-hidden': true,
          },
          style: {
            top: 0,
            bottom: 0,
            borderWidth: '1px',
          },
        },
        [this.genLabel()]
      )
    },
    genDefaultSlot() {
      const selections = this.genSelections()
      const input = this.genInput() // If the return is an empty array
      // push the input

      if (Array.isArray(selections)) {
        selections.push(input) // Otherwise push it into children
      } else {
        selections.children = selections.children || []
        selections.children.push(input)
      }

      return [
        this.genFieldset(),
        this.$createElement(
          'div',
          {
            staticClass: 'v-select__slot',
            directives: this.directives,
          },
          [
            this.prefix ? this.genAffix('prefix') : null,
            selections,
            this.suffix ? this.genAffix('suffix') : null,
            this.genClearIcon(),
            this.genIconSlot(),
            this.genHiddenInput(),
          ]
        ),
        this.genMenu(),
        this.genProgress(),
      ]
    },
  },
}
</script>
